// Customer dashboard reads/writes — GET/PUT /customer/* (routes/
// customerRoutes.js, requireRole('customer') + an organization_id scope
// check server-side on every route). Query keys are 'customer'-namespaced,
// distinct from the public 'public'/catalog-browse keys usePublicCatalog.js
// already owns.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apiClient from 'shared/api/client.js';

export function useMyRequests() {
  return useQuery({
    queryKey: ['customer', 'requests'],
    queryFn: () => apiClient.get('/customer/requests'),
    select: (data) => data.requests,
  });
}

export function useMyRequestDetail(requestId) {
  return useQuery({
    queryKey: ['customer', 'requests', requestId],
    queryFn: () => apiClient.get(`/customer/requests/${requestId}`),
    enabled: Boolean(requestId),
  });
}

export function useMyOrganization() {
  return useQuery({
    queryKey: ['customer', 'organization'],
    queryFn: () => apiClient.get('/customer/organization'),
    select: (data) => data.organization,
  });
}

export function useUpdateMyOrganization() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (patch) => apiClient.put('/customer/organization', patch),
    onSuccess: (data) => {
      queryClient.setQueryData(['customer', 'organization'], data);
    },
  });
}

// POST /customer/account/delete — deletes this login's name/email/phone; the
// organization record, its requests, and its issued proformas are kept
// (commercial/tax records). The server destroys the session as part of the
// same response, so there is deliberately no cache write here the normal
// way — the calling page's own success handler clears the auth cache and
// navigates away (see AccountSettingsPage.jsx).
export function useDeleteMyAccount() {
  return useMutation({
    mutationFn: (confirmation) => apiClient.post('/customer/account/delete', { confirmation }),
  });
}
